export default function Django_Create_Config() {
  return <div>Django_Create_Config Component</div>;
}
